import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';

import { makePair, Pair } from '../../../../../adl-gen/sys/types';
import { AnswerIndex, I18nContent, Score } from '../../../../../adl-gen/totalinteraction/futurefit/db';
import { LangCode, withI18n, WithI18nProps } from '../../../../../internationalization/i18n-hoc';
import { Table, TableCell, TableRow } from '../../../../../ui/widgets/table/table';
import {
  FieldState,
  FormValue,
  newIntegerFieldState,
  withValueCallback
} from '../../../../../ui/widgets/text-input/text-field';
import { WithId } from '../../../../../util/utils';
import { TextInputObserver } from '../../../common/editor';
import { DnDContainer, DraggableEditorOption } from '../../drag-and-drop/drag-and-drop-container';

const styles = require('../../../common/editor.css');
const listStyles = require('../../../common/list.css');
// const fonts = require("../../../../ui/common/fonts.css")

type OrderedResponseInputScore = Pair<AnswerIndex[], FieldState<number>>;

export interface OrderedResponseScoreSetEditorProps extends WithI18nProps {
  debug?: boolean;
  lang?: LangCode;
  /// Not using IDs
  answers: WithId<I18nContent>[];
  /// Extracted from AnswerPermsScores
  answerPermScore?: Pair<AnswerIndex[], Score>;
  // /// Index into AnswerPermsScores array
  // answerIndex: number
  postUpdates(score: Pair<AnswerIndex[], Score>): void;
}

/**
 * Component to update one permutation (set) of OrderedResponse answers.
 */
@observer
class OrderedResponseScoreSetEditor0 extends React.Component<OrderedResponseScoreSetEditorProps> {
  @observable inputAnswerPermScore: OrderedResponseInputScore;

  lang: LangCode;

  constructor(props: Readonly<OrderedResponseScoreSetEditorProps>) {
    super(props);
    this.lang = props.lang ? props.lang : props.currentLangCode();
    const { answerPermScore: score, answers } = props;

    const defaultPerm = answers.map((_v, i) => i);

    if (score) {
      this.inputAnswerPermScore = makePair({
        v1: score.v1,
        v2: withValueCallback(newIntegerFieldState(0, 100), this.onChangeScore)
      });
      this.inputAnswerPermScore.v2.onChange(`${score.v2}`);
    } else {
      this.inputAnswerPermScore = makePair({
        v1: defaultPerm,
        v2: withValueCallback(newIntegerFieldState(0, 100), this.onChangeScore)
      });
    }
  }

  AnswerSetScoreObserver = observer((props: { v1: number[] }) =>
    TextInputObserver({
      field: this.inputAnswerPermScore.v2,
      type: 'number',
      title: `Score for answer ${props.v1.map(v => v + 1).join('|')}`,
      placeholder: 'eg. 33',
      xsSpan: 2,
      debug: this.props.debug
    })
  );

  @computed
  get inputIsValid(): boolean {
    let isValid: boolean = true;
    // const { answers } = this.props
    // const { defaultScore, answerPermsScores } = this.inputScores.value
    // isValid = defaultScore.getValid() !== undefined &&
    //       !isEmpty(defaultScore) &&
    //       isNumeric(defaultScore.value())
    // if (isValid) {
    //   isValid = answerPermsScores.every(score => {
    //     return score.v1.length === answers.length &&
    //            score.v1.every(item => item >= 0 && item < answers.length) &&
    //            score.v2.getValid() !== undefined &&
    //            !isEmpty(score.v2) &&
    //            isNumeric(score.v2.value())
    //   })
    // }
    return isValid;
  }

  @action
  onChangeScore = (_score: FormValue<number>) => {
    /// Post
    this.onSave();
  };

  @action
  onSave = () => {
    const { postUpdates } = this.props;
    if (this.inputIsValid) {
      const v2 = this.inputAnswerPermScore.v2.getValid();
      /// Will not post anything until a score is set
      if (v2 !== undefined) {
        postUpdates(makePair({ v1: this.inputAnswerPermScore.v1, v2 }));
      }
    }
  };

  @action
  onReorderAnswerSet = (newIdOrder: number[]) => {
    this.inputAnswerPermScore.v1 = newIdOrder;
    this.onSave();
  };

  AnswerSetObserver = observer((props: { answers: I18nContent[]; permutation: AnswerIndex[] }) => {
    const { t } = this.props;
    // DnDContainer from answers text in score.v1 order
    // // Default order on first render
    // let draggableAnswers: DraggableEditorOption[] = answers.map((ac, id) => (
    //   {
    //     id,
    //     element: t(ac, this.lang)
    //   }))
    /// --- [ TODO adding new answers, deleting answers ] ---
    // const draggableAnswers: DraggableEditorOption[] = props.answers.map((answer, i) => ({
    //   id: props.permutation[i],
    //     element: t(answer, this.lang)
    //   })
    // )
    const draggableAnswers: DraggableEditorOption[] = props.permutation.map(perm => ({
      id: perm,
      element: t(props.answers[perm], this.lang)
    }));
    return (
      <DnDContainer draggableOptions={draggableAnswers} onMove={c => this.onReorderAnswerSet(c.map(item => item.id))} />
    );
  });

  Edit = () => {
    const { answers } = this.props;
    return (
      <div className={styles.page}>
        <div className={styles.body}>
          <Table className={listStyles.noBorder}>
            <TableRow>
              <TableCell
              // key={index}
              >
                <div
                  className={styles.row}
                  // key={index}
                >
                  <this.AnswerSetObserver
                    answers={answers.map(answer => answer.value)}
                    permutation={this.inputAnswerPermScore.v1}
                  />
                  <this.AnswerSetScoreObserver v1={this.inputAnswerPermScore.v1} />
                </div>
              </TableCell>
            </TableRow>
          </Table>
        </div>
      </div>
    );
  };

  render() {
    return <this.Edit />;
  }
}

export const OrderedResponseScoreSetEditor = withI18n(OrderedResponseScoreSetEditor0);



// WEBPACK FOOTER //
// ./src/admin/ui/components/editors/answers-scoring-editors/ordered-response-score-set-editor.tsx